import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/useAuth";

export function usePoints() {
  const { user } = useAuth();
  const queryClient = useQueryClient();

  const { data: balance = 0, isLoading } = useQuery({
    queryKey: ["points", user?.id],
    queryFn: async () => {
      const { data, error } = await supabase.rpc("ensure_user_points", {
        _user_id: user!.id,
      });
      if (error) throw error;
      return data as number;
    },
    enabled: !!user,
  });

  const addPointsMutation = useMutation({
    mutationFn: async (points: number) => {
      const { data, error } = await supabase.rpc("add_points", {
        _user_id: user!.id,
        _points: points,
      });
      if (error) throw error;
      return data as number;
    },
    onSuccess: (newBalance) => {
      queryClient.setQueryData(["points", user?.id], newBalance);
    },
  });

  return { balance, isLoading, addPoints: addPointsMutation.mutateAsync };
}
